import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { isSignInWithEmailLink } from 'firebase/auth';

import { auth } from '../../../api/firebase/config';
import { throwError } from '../../../modules/error';
import CustomLoading from '../../uiParts/CustomLoading';
import Header from '../../uiParts/Header';

const Action: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const oobCode = queryParams.get('oobCode') ?? '';

  useEffect(() => {
    setLoading(true);
    try {
      if (isSignInWithEmailLink(auth, window.location.href)) {
        const decodeUrl = new URL(decodeURIComponent(window.location.href));
        const params = decodeUrl.searchParams;
        const url = new URL(params.get('continueUrl') ?? '');
        const secondParams = url.searchParams;
        const email = secondParams.get('email')?.split('?').join('') ?? '';

        if (window.location.href.includes('publisher')) {
          navigate(`/publisher/auth/basic` + `?email=${email}&anchor=login`);
        } else if (window.location.href.includes('agent')) {
          navigate(`/agent/auth/basic` + `?email=${email}&anchor=login`);
        } else if (window.location.href.includes('client')) {
          navigate(`/client/auth/basic` + `?email=${email}&anchor=login`);
        } else if (window.location.href.includes('invite')) {
          navigate(`/auth/invite/register` + `?email=${email}&anchor=login`);
        }
      } else {
        navigate(`/auth/password_change` + `?oobCode=${oobCode}`);
      }
    } catch (e) {
      throwError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <CustomLoading loading={loading} />
      <Header />
    </>
  );
};

export default Action;
